module.exports = __webpack_public_path__ + "img/icon_app.b0862493.png";